import { Drawer as VaulDrawer, DialogProps } from "vaul";
import classNames from "classnames";
import { ArrowRightIcon } from "../../../icons";
import { Button } from "../Button/Button";
import styles from "./Drawer.module.scss";

interface CustomProps {
    children: React.ReactNode;
    contentClassName?: string;
    headerAddon?: React.ReactNode;
}

export const Drawer: React.FC<CustomProps & DialogProps> = ({
    children,
    contentClassName,
    headerAddon,
    ...props
}) => (
    <VaulDrawer.Root {...props}>
        <VaulDrawer.Overlay className={styles.overlay} />
        <VaulDrawer.Portal>
            <VaulDrawer.Content
                className={classNames(styles.content, contentClassName)}
            >
                <header className={styles.header}>
                    <VaulDrawer.Close asChild>
                        <Button variant="link" icon>
                            <ArrowRightIcon />
                        </Button>
                    </VaulDrawer.Close>
                    {headerAddon}
                </header>
                {children}
            </VaulDrawer.Content>
        </VaulDrawer.Portal>
    </VaulDrawer.Root>
);
